export const DATEPICKER_SELECTORS = {
  daySelected: '.react-datepicker__day--selected',
  dayInSelectingRange: '.react-datepicker__day--in-selecting-range',
  daySelectingRangeStart: '.react-datepicker__day--selecting-range-start',
  daySelectingRangeEnd: '.react-datepicker__day--selecting-range-end',
  dayOutsideMonth: '.react-datepicker__day--outside-month',
  dayKeyboardSelected: '.react-datepicker__day--keyboard-selected',
  dayToday: '.react-datepicker__day--today',
  dayWeekend: '.react-datepicker__day--weekend',
  dayDisabled: '.react-datepicker__day--disabled',
  dayInRange: '.react-datepicker__day--in-range',
  dayRangeStart: '.react-datepicker__day--range-start',
  dayRangeEnd: '.react-datepicker__day--range-end',

  daySelectedButton: '.react-datepicker__day--selected > button',
  dayInSelectingRangeButton: '.react-datepicker__day--in-selecting-range > button',
  daySelectingRangeStartButton: '.react-datepicker__day--selecting-range-start > button',
  daySelectingRangeEndButton: '.react-datepicker__day--selecting-range-end > button',
  dayOutsideMonthButton: '.react-datepicker__day--outside-month > button',
  dayKeyboardSelectedButton: '.react-datepicker__day--keyboard-selected > button',
  dayTodayButton: '.react-datepicker__day--today > button',
  dayWeekendButton: '.react-datepicker__day--weekend > button',
  dayDisabledButton: '.react-datepicker__day--disabled > button',
  dayInRangeButton: '.react-datepicker__day--in-range > button',
  dayRangeStartButton: '.react-datepicker__day--range-start > button',
  dayRangeEndButton: '.react-datepicker__day--range-end > button',

  dayNames: '.react-datepicker__day-names',
  week: '.react-datepicker__week',
  month: '.react-datepicker__month',
  calendar: '.react-datepicker',
  header: '.react-datepicker__header',

  navigationIcon: '.react-datepicker__navigation-icon',
  navigationIconNext: '.react-datepicker__navigation-icon--next',
  navigationIconPrevious: '.react-datepicker__navigation-icon--previous',

  ariaLiveMonthValue: '.react-datepicker__aria-live'
} as const

export const DAY_RANGE_START_BG_SELECTOR =
  `${DATEPICKER_SELECTORS.dayInRange}${DATEPICKER_SELECTORS.dayRangeStart}, ${DATEPICKER_SELECTORS.dayInSelectingRange}${DATEPICKER_SELECTORS.daySelectingRangeStart}` as const

export const DAY_RANGE_END_BG_SELECTOR =
  `${DATEPICKER_SELECTORS.dayInRange}${DATEPICKER_SELECTORS.dayRangeEnd}, ${DATEPICKER_SELECTORS.dayInSelectingRange}${DATEPICKER_SELECTORS.daySelectingRangeEnd}` as const

export const SELECTED_DAYS_BUTTONS_SELECTOR =
  `${DATEPICKER_SELECTORS.daySelectingRangeEndButton}, ${DATEPICKER_SELECTORS.daySelectingRangeStartButton}, ${DATEPICKER_SELECTORS.dayRangeStartButton}, ${DATEPICKER_SELECTORS.dayRangeEndButton}` as const
